import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';
import { makeEmployeeLabel } from 'utils/employee.utils';

interface ISalespersonName {
  className?: string;
  salesperson: IEmployeeBasicInfo;
}

const SalespersonName: FC<ISalespersonName> = ({ salesperson, className }) => {
  return (
    <Grid container wrap="nowrap" alignItems="center" spacing={1}>
      <Grid item>
        <Typography className={className}>{makeEmployeeLabel(salesperson)}</Typography>
      </Grid>
    </Grid>
  );
};

export default SalespersonName;
